<template>

  <div class="coq-modal">
    <div class="coq-modal__top-right">
      <a @click="$emit('close')">
        <font-awesome-icon icon="times" type="fas" size="lg"/>
      </a>
    </div>

    <h3>Modifier mon mot de passe</h3>
    <p style="width: 100%; text-align: center">Vous pouvez ici modifier votre mot de passe.</p>
    <br/>

    <b-form-row>
      <b-col>
        <b-form-group label="Mot de passe actuel">
          <b-form-input
              v-model="currentPassword"
              class="form-control"
              type="password"
              :state="validateState('currentPassword')"
              aria-describedby="input-password-feedback"
              ref="currentPassword"
          />
          <password-toggle :input="$refs['currentPassword']"/>
          <b-form-invalid-feedback id="input-password-feedback">
            <template v-if="!$v.currentPassword.required || !$v.currentPassword.minLength">
              Votre mot de passe doit contenir un minimum de 6 caractères.
            </template>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group label="Nouveau mot de passe">
          <b-form-input
              v-model="password"
              class="form-control"
              type="password"
              :state="validateState('password')"
              aria-describedby="input-password-feedback"
              ref="password"
          />
          <password-toggle :input="$refs['password']"/>
          <b-form-invalid-feedback id="input-password-feedback">
            <template v-if="!$v.password.required || !$v.password.minLength">
              Votre mot de passe doit contenir un minimum de 6 caractères.
            </template>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-form-row>
    <b-form-row>
      <b-col>
        <b-form-group label="Confirmation du nouveau mot de passe">
          <b-form-input
              v-model="passwordConfirmation"
              type="password"
              :state="validateState('passwordConfirmation')"
              aria-describedby="input-password-confirm-feedback"
              ref="password-confirmation"
          />
          <password-toggle :input="$refs['password-confirmation']"/>
          <b-form-invalid-feedback id="input-password-confirm-feedback">
            <template v-if="!$v.passwordConfirmation.required || !$v.passwordConfirmation.minLength">
              Votre mot de passe doit contenir un minimum de 6 caractères.
            </template>
            <template v-else-if="!$v.passwordConfirmation.sameAs">
              La confirmation du mot de passe doit être identique au mot de passe.
            </template>
          </b-form-invalid-feedback>
        </b-form-group>
      </b-col>
    </b-form-row>

    <template v-if="error">
      <span class="error" style="padding-left: 10px">{{ error }}</span>
    </template>

    <div class="coq-modal__footer">
      <b-button variant="primary" style="width: 100%" @click="validateBeforeSubmit">
        <template v-if="loading">
          <font-awesome-icon icon="spinner" spin/>
        </template>
        <template v-else>
          Confirmer la modification
        </template>
      </b-button>
    </div>

  </div>

</template>

<script>
  import { mapActions, mapState } from 'vuex';
  import PasswordToggle from '@/components/inputs/password-toggle';
  const { required, minLength, sameAs } = require('vuelidate/lib/validators');

  export default {
    name: 'update-user-password',
    components: { PasswordToggle },
    data() {
      return {
        error: null,
        loading: false,
        currentPassword: '',
        password: '',
        passwordConfirmation: ''
      };
    },
    validations: {
      currentPassword: {
        required,
        minLength: minLength(6)
      },
      password: {
        required,
        minLength: minLength(6)
      },
      passwordConfirmation: {
        required,
        sameAs: sameAs('password'),
        minLength: minLength(6)
      }
    },
    computed: {
      ...mapState({
        resetting: state => state.account.status.resettingPassword
      })
    },
    methods: {
      ...mapActions('account', [ 'changePassword' ]),
      validateBeforeSubmit() {
        this.loading = true;
        try {
          if (this.check() === true) {
            this.changePassword({
              currentPassword: this.currentPassword,
              password: this.password,
              passwordConfirmation: this.passwordConfirmation
            })
              .then(success => {
                this.error = null;
                this.$swal({
                  title: 'Mot de passe',
                  text: 'Votre mot de passe a été modifié avec succès.',
                  confirmButtonText: 'Fermer'
                });
              })
              .then(() => {
                this.$emit('close');
              })
              .catch(error => {
                this.error = error;
              });
          }
        }
        finally {
          this.loading = false;
        }
      },
      validateState(name) {
        const { $dirty, $error } = this.$v[name];
        return $dirty ? !$error : null;
      },
      setField(field, street) {
        this[field] = street;
        this.$v[field].$touch();
      },
      check() {
        this.$v.$touch();
        return !this.$v.$anyError;
      }
    }
  };
</script>

<style scoped>
.error {
  color: #dc3545;
}
</style>
